
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.5 9.778l2.462-2.624a.475.475 0 01.692 0 .539.539 0 010 .737l-2.926 3.117a1 1 0 01-1.458 0L4.346 7.892a.54.54 0 01.022-.76.475.475 0 01.671.022L7.5 9.776V3.5a.5.5 0 011 0zM2 13.5a.5.5 0 01.5-.5h11a.5.5 0 110 1h-11a.5.5 0 01-.5-.5z","fill-rule":"evenodd"}})])
          )
        }
      }
    